


























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import WorkshopsOverview from "./WorkshopsOverview.vue";
import WorkshopsAll from "./WorkshopsAll.vue";
import WorkshopsParticipants from "./WorkshopsParticipants.vue";
import WorkshopsPayments from "./WorkshopsPayments.vue";
import WorkshopsWorkshops from "./WorkshopsWorkshops.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Workshops",
  components: {
    MainTabbar,
    WorkshopsParticipants,
    WorkshopsOverview,
    WorkshopsAll,
    WorkshopsPayments,
    WorkshopsWorkshops,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
      WorkshopsBookingStatusNames: {
        requested: "Bestätigung benötigt",
        waitingList: "Auf Warteliste",
        bookedReadyForDepositPayment: "Bereit für Anzahlung",
        bookedDepositPaymentExported: "Gebucht, Anzahlung exportiert",
        readyForPayment: "Bereit für Bezahlung",
        paymentExported: "Rechnung wurde exportiert",
        canceled: "Abgesagt, Gebühr-Export ausstehend",
        cancellationFeeExported: "Abgesagt, Gebühr wurde exportiert",
      },
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Übersicht",
          linkedComponent: "WorkshopsOverview",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleWorkshops),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleWorkshops),
        },
        {
          title: "Teilnehmende",
          linkedComponent: "WorkshopsParticipants",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleWorkshops),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleWorkshops),
        },
        {
          title: "Alle Plätze",
          linkedComponent: "WorkshopsAll",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleWorkshops),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleWorkshops),
        },
        {
          title: "Zahlungen",
          linkedComponent: "WorkshopsPayments",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
        },
        {
          title: "Kurse",
          linkedComponent: "WorkshopsWorkshops",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleWorkshops),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleWorkshops),
        },
      ] as ModulesJson[];
    },
  },
});
